module.exports = __webpack_public_path__ + "media/images/city_img/g-2d1ff69613240f877e47d9f0cba97127.jpg";